export default (parameters: string[]): string => (parameters.length > 0 ? '?' + parameters.join('&') : '');



// WEBPACK FOOTER //
// ./src/application/products/epic/combineQueryParameters.ts